module.exports = __webpack_public_path__ + "img/IMG-20200919-WA0088.a82e8b35.jpg";